import React from 'react'
import { useState } from 'react'
import { Container, Wrapper, Title, Desc, CardContainer, ToggleButtonGroup, ToggleButton, Divider } from './ProjectsStyle'
import ProjectCard from '../Cards/ProjectCards'
import { projects } from '../../data/constants'


const Projects = ({openModal,setOpenModal}) => {
  const [toggle, setToggle] = useState('all');
  return (
    <Container id="projects">
      <Wrapper>
        <Title>Projects</Title>
        <Desc>
          I have worked on a wide range of projects.Using different frameworks. Here are some of my projects in different frameworks.
        </Desc>
        <ToggleButtonGroup >
          {toggle === 'all' ?
            <ToggleButton active value="all" onClick={() => setToggle('all')}>All</ToggleButton>
            :
            <ToggleButton value="all" onClick={() => setToggle('all')}>All</ToggleButton>
          }
          <Divider />
          {toggle === 'java' ?
            <ToggleButton active value="java" onClick={() => setToggle('java')}>java APP'S</ToggleButton>
            :
            <ToggleButton value="java" onClick={() => setToggle('java')}>java APP'S</ToggleButton>
          }
          <Divider />
          {toggle === 'android app' ?
            <ToggleButton active value="react" onClick={() => setToggle('react')}>React APP'S</ToggleButton>
            :
            <ToggleButton value="react" onClick={() => setToggle('react')}>React APP'S</ToggleButton>
          }
          <Divider />
          {toggle === 'djo' ?
            <ToggleButton active value="djo" onClick={() => setToggle('machine learning')}>Django</ToggleButton>
            :
            <ToggleButton value="djo" onClick={() => setToggle('djo')}>Django</ToggleButton>
          }
        </ToggleButtonGroup>
        <CardContainer>
          {toggle === 'all' && projects
            .map((project) => (
              <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal}/>
            ))}
          {projects
            .filter((item) => item.category === toggle)
            .map((project) => (
              <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal}/>
            ))}
        </CardContainer>
      </Wrapper>
    </Container>
  )
}

export default Projects